module.exports = __webpack_public_path__ + "static/media/2_graph2.5801d6aa.svg";